import { createSelector } from '@ngrx/store';
import { selectLookupFeatureState } from '../lookup.selectors';


export const selectLookupState = createSelector(
    selectLookupFeatureState,
    s => s?.state
);
export const selectLookupStateLoaded = createSelector(selectLookupState, s => !!s);

export const selectLookupAvailability = createSelector(selectLookupState, s => s?.available);
export const selectLookupUnavailabilityMessage = createSelector(selectLookupState, s => s?.unavailabilityMessage);

export const selectLookupServices = createSelector(selectLookupState, s => s?.lookupServices);
export const selectLookupService = (serviceId: string) => createSelector(
    selectLookupServices,
    s => s?.find(service => service.id === serviceId)
);
export const selectLookupServiceAvailable = (serviceId: string) => createSelector(
    selectLookupAvailability,
    selectLookupServices,
    (lookupAvailable, lookupServices) =>
        lookupAvailable
        &&
        (
            lookupServices
            ? !!lookupServices.find(service => service.id === serviceId)?.available
            : lookupServices
        )
);
export const selectLookupServiceInstructions = (serviceId: string) => createSelector(
    selectLookupServices,
    lookupServices => lookupServices
        ? lookupServices.find(service => service.id === serviceId)?.instructions
        : lookupServices
);

export const selectLookupServiceMessages = (serviceId: string) => createSelector(
    selectLookupServices,
    s => s?.find(service => service.id === serviceId)?.messages
);

export const selectLookupFindOutMore = createSelector(selectLookupState, s => s?.moreInfo);
export const selectLookupHasFindOutMore = createSelector(selectLookupFindOutMore, mi => !!mi?.length);
